/* eslint-disable max-len */
import loadable from '@loadable/component';
import tinkoff from '@tcb-web/create-credit';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useAlert } from 'react-alert';
import { useMutation, useQuery } from '@apollo/client';
import { Container } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import ReactPlayer from 'react-player/lazy';
import { Link, useHistory } from 'react-router-dom';
import ym from 'react-yandex-metrika';
import styled, { css } from 'styled-components';
import Cookies from 'universal-cookie';

import config from '../../config';
import {
  GQL_GET_ME,
  GQL_PAY_STATUS,
  GQL_GET_EDUCATION,
  GQL_PAY_EDUCATION_PROGRESS,
  GQL_PROMO_EDUCATION,
  GQL_PAY_FREE,
  GQL_CREATE_PAYMENT,
} from '../../graphql/queries';
import {
  CURRENCY_RUB,
  declinationName,
  EDUCATION_SECTION,
  EDUCATIONS_SECTION,
  getCurrency,
  getTimeDateRange,
  renderStringToComponents,
  scrollElementId,
  splitName,
} from '../../helpers/main';
import { DescriptionStyle } from '../../helpers/pageStyles';
import {
  MODE_NORMAL,
  MODE_INSTALLMENTS,
  paymentProcess,
  FULL_DISCOUNT,
  MODE_MODULES,
} from '../../helpers/payment';
import useInViewport from '../../components/hooks/useInViewport';
import useWindowSize from '../../components/hooks/useWindowSize';
import { useTranslation } from '../../components/hooks/useTranslation';
import { RU_DOMAIN } from '../../locales';

const Error = loadable(() => import('../Error'));
const Icon = loadable(() => import('../../components/Icon'));
const FaqBlock = loadable(() => import('../../components/Faq'));
const MetaTags = loadable(() => import('../../components/MetaTags'));
const RenderNews = loadable(() => import('../../components/news/news'));
const Tariff = loadable(() => import('../../components/educations/tariff'));
const HiddenTariff = loadable(() => import('../../components/HiddenTariff'));
const CourseModule = loadable(() => import('../../components/educations/module'));
const RegistrationBlock = loadable(() => import('../../components/RegistrationBlock'));
const VariantModal = loadable(() => import('../../components/educations/variantModal'));
const RenderSameCourses = loadable(() => import('../../components/educations/courses'));
const SlickSlider = loadable(() => import('../../components/SlickSlider'), { ssr: false });
const SuccessModal = loadable(() => import('../../components/educations/successModal'), {
  ssr: false,
});

const EducationView = ({ match, ChatContext }) => {
  const param = !_.get(match, 'params.id')
    ? { url: _.get(match, 'params.url') }
    : { _id: _.get(match, 'params.id') };
  const timeNow = Math.floor(Date.now() / 1000);
  let hasButton = false;

  const { t } = useTranslation();
  const alert = useAlert();
  const history = useHistory();
  const context = useContext(ChatContext);
  const { isInViewport, ref } = useInViewport({ offset: 10, throttleMilliseconds: 100 });
  const { width } = useWindowSize();
  const cookies = new Cookies();

  const [collapse, collapseIt] = useState(null);
  const [payLoading, setPayLoading] = useState(false);
  const [isPromo, setPromo] = useState(null);
  const [newPrice, setNewPrice] = useState(null);
  const [newEuroPrice, setNewEuroPrice] = useState(null);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [lecturers, setLecturers] = useState([]);
  const [tariffs, setTariffs] = useState([]);
  const [program, setProgram] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [videoReviews, setVideoReviews] = useState([]);
  const [faq, setFaq] = useState([]);
  const [modules, setModules] = useState([]);
  const [video, setVideo] = useState(false);
  const [variant, setVariant] = useState(false);
  const [lecturesNames, setLecturesNames] = useState([]);

  const [promoProcess] = useMutation(GQL_PROMO_EDUCATION);
  const [payStatus] = useMutation(GQL_PAY_STATUS);
  const [payFree] = useMutation(GQL_PAY_FREE);
  const [createPayment] = useMutation(GQL_CREATE_PAYMENT);
  const [payProgress] = useMutation(GQL_PAY_EDUCATION_PROGRESS);

  const { data: dataMe } = useQuery(GQL_GET_ME, { fetchPolicy: 'cache-only' });

  const me = _.get(dataMe, 'me', null);

  const { data, loading, error } = useQuery(GQL_GET_EDUCATION, {
    variables: param,
  });

  const errors = _.get(error, 'graphQLErrors', []);

  const item = _.get(data, 'education', null);

  if (_.get(item, 'button_register') && _.get(item, 'button_unregister')) {
    hasButton = _.get(me, '_id')
      ? _.get(item, 'button_register')
      : _.get(item, 'button_unregister');
  }

  useEffect(() => {
    ym('hit', `/educations/${_.get(match, 'params.url') || _.get(match, 'params.id')}`, {
      params: { user: _.get(dataMe, 'me._id') },
    });
  }, []);

  useEffect(() => {
    setLecturers(_.get(item, 'lecturers', []));
    setTariffs(_.get(item, 'tariffs', []));
    setProgram(_.get(item, 'program', []));
    setFaq(_.get(item, 'faq', []));
    setReviews(_.get(item, 'reviews', []));
    setVideoReviews(_.get(item, 'videoReviews', []));
    setModules(_.get(item, 'modules', []));
    return () => {
      setLecturers([]);
      setFaq([]);
      setTariffs([]);
      setProgram([]);
      setReviews([]);
      setVideoReviews([]);
    };
  }, [
    _.get(item, 'program'),
    _.get(item, 'lecturers'),
    _.get(item, 'blocks'),
    _.get(item, 'tariffs'),
    _.get(item, 'faq'),
    _.get(item, 'reviews'),
    _.get(item, 'videoReviews'),
    _.get(item, 'modules'),
  ]);

  useEffect(() => {
    if (!_.isEmpty(_.get(item, 'lecturers', [])) && _.isArray(item.lecturers) && !_.isEmpty(item.lecturers)) {
      const names = [];
      item.lecturers.filter((l) => !!l.name).forEach((l, i) => {
        names.push(
          <LinkName to={`/@${_.get(l, 'username') || _.get(l, '_id')}`} key={l._id}>
            {l.name}
            {_.has(item.lecturers, i + 1) ? ', ' : ''}
          </LinkName>,
        );
      });
      setLecturesNames(names);
    }
  }, [_.get(item, 'lecturers')]);

  if (!_.isEmpty(errors)) {
    return <Error errors={errors} />;
  }

  if (!loading && !item) {
    return (<Error errors={[]} />);
  }

  const isOpen = _.get(item, 'started_at') ? _.get(item, 'started_at') <= timeNow : true;

  const scrollToPrice = () => {
    const el = document.getElementById('tariffs');
    const y = el.getBoundingClientRect().top + window.pageYOffset - (width < 600 ? 80 : 200);
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  const goAuth = () => {
    alert.show(t('login_pay', { ns: 'education' }), { type: 'warning' });
    cookies.set('goto', `/educations/${_.get(item, 'url') || _.get(item, '_id')}`);
    history.push('/login');
    return false;
  };

  const successGo = () => {
    alert.show(t('success_payed', { ns: 'education' }), { type: 'success' });
    if (_.get(item, 'redirect_success') && item.redirect_success) {
      setModalSuccess(true);
      setTimeout(() => window.open(item.redirect_success, '_blank'), 7000);
    } else if (!isOpen) {
      history.push('/account/educations');
    } else {
      history.push(`/account/educations/${_.get(item, 'url') || _.get(item, '_id')}`);
    }
    setPayLoading(false);
  };

  const freeCourse = async () => {
    if (!_.get(me, '_id') || !me._id) {
      goAuth();
      return false;
    }
    if (!_.get(item, '_id')) {
      alert.show(t('error_payment', { ns: 'education' }), { type: 'danger' });
      return false;
    }
    try {
      setPayLoading(true);
      const response = await payFree({
        variables: {
          item_id: item._id,
          model: EDUCATION_SECTION,
        },
      });
      const e = _.get(response, 'errors[0]', {});
      if (_.isEmpty(e)) {
        const result = _.get(response, 'data.itemFree', {});
        if (result) {
          successGo();
          return true;
        }
      }
      alert.show(e.message, { type: 'danger' });
      setPayLoading(false);
      return false;
    } catch (e) {
      alert.show(t('error_payment', { ns: 'education' }), { type: 'danger' });
      setPayLoading(false);
      // eslint-disable-next-line no-console
      console.log(e);
      return false;
    }
  };

  const _installment = async ({ model, promoBankCode }) => {
    if (!_.get(me, '_id') || !me._id || !promoBankCode) {
      goAuth();
      return false;
    }
    const isProduction = _.get(config, 'hostname') === 'artocratia.ru';
    if (_.isEmpty(model)) {
      return false;
    }
    setPayLoading(true);
    if (+model.price < 8000) {
      return false;
    }
    const response = await createPayment({
      variables: {
        tariff_id: model._id,
        promo: _.get(isPromo, 'promo', null),
        model: EDUCATION_SECTION,
        mode: MODE_INSTALLMENTS,
      },
    });
    const e = _.get(response, 'errors[0]', {});
    const ID = _.get(response, 'data.createPayment', null);
    if (ID && _.isEmpty(e)) {
      setVariant(false);
      const { firstName, lastName, middleName } = splitName(_.get(me, 'name'));
      const func = isProduction ? tinkoff.create : tinkoff.createDemo;
      await func(
        {
          shopId: _.get(config, 'tinkoff.shopId'),
          showcaseId: _.get(config, 'tinkoff.showcaseId'),
          items: [{ name: model.name, price: +model.price, quantity: 1 }],
          promoCode: promoBankCode,
          orderNumber: ID,
          webhookURL: `${RU_DOMAIN}/api/payment/tinkoff/${ID}`,
          values: {
            contact: {
              fio: {
                firstName,
                lastName,
                middleName,
              },
              mobilePhone: _.get(me, 'phone', '+70000000000'),
              email: _.get(me, 'email', 'your@email.com'),
            },
          },
          sum: +model.price,
        },
        { view: 'modal' },
      );
      tinkoff.methods.on(tinkoff.constants.SUCCESS, (payload) => {
        setTimeout(() => {
          payload.meta.iframe.destroy();
          successGo();
        }, 5000);
      });
      setPayLoading(false);
      return true;
    }
    if (!_.isEmpty(e)) {
      alert.show(e.message, { type: 'danger' });
    }
    setVariant(false);
    setPayLoading(false);
    return false;
  };

  const _bye = async (model) => {
    if (!_.get(me, '_id') || !me._id) {
      goAuth();
      return false;
    }
    if (_.isEmpty(model)) {
      return false;
    }
    setPayLoading(true);
    try {
      const response = await payProgress({
        variables: {
          mode: MODE_NORMAL,
          promo: _.get(isPromo, 'promo', null),
          model_id: _.get(model, '_id'),
        },
      });
      const e = _.get(response, 'errors[0]', {});
      const paymentToken = _.get(response, 'data.payEducation', {});
      if (_.isEmpty(e) && paymentToken) {
        if (paymentToken === FULL_DISCOUNT) {
          successGo();
          return true;
        }
        if (paymentToken && typeof window !== 'undefined') {
          await paymentProcess({
            token: paymentToken,
            payStatus,
            refetchQueries: [
              {
                query: GQL_GET_ME,
                fetchPolicy: 'network-only',
              },
            ],
            onSuccess: () => {
              successGo();
            },
            onFiled: () => {
              alert.show(t('error_payment', { ns: 'education' }), { type: 'danger' });
              setPayLoading(false);
            },
            onCancel: () => {
              setPayLoading(false);
            },
          });
          return true;
        }
      } else {
        alert.show(e.message, { type: 'danger' });
        setPayLoading(false);
      }
      return false;
    } catch (e) {
      alert.show(t('error_payment', { ns: 'education' }), { type: 'danger' });
      setPayLoading(false);
      // eslint-disable-next-line no-console
      console.log(e);
      return false;
    }
  };

  const promo = async (values, { setSubmitting }) => {
    if (!_.get(me, '_id') || !me._id) {
      goAuth();
      return false;
    }
    const response = await promoProcess({
      variables: {
        promo: values.promo,
        tariff_id: values._id,
      },
    });
    const e = _.get(response, 'errors[0]', null);
    if (e) {
      setSubmitting(false);
      alert.show(e.message, { type: 'danger' });
      return false;
    }
    const price = _.get(response, 'data.promoEducation.total', null);
    const price_euro = _.get(response, 'data.promoEducation.total_euro', null);
    if (price || price_euro) {
      setPromo(values);
      setNewPrice(price);
      setNewEuroPrice(price_euro);
      alert.show(t('promo_success', { ns: 'education' }), { type: 'success' });
      scrollElementId(`tariff-${values._id}`);
    }
    return true;
  };

  const _stripePay = async (model) => {
    if (!_.get(me, '_id') || !me._id) {
      goAuth();
      return false;
    }
    if (_.isEmpty(model)) {
      return false;
    }
    const response = await payProgress({
      variables: {
        mode: MODE_NORMAL,
        promo: _.get(isPromo, 'promo', null),
        model_id: _.get(model, '_id'),
        stripe: true,
      },
    });
    const e = _.get(response, 'errors[0]', {});
    const paymentToken = _.get(response, 'data.payEducation', {});
    if (_.isEmpty(e) && paymentToken) {
      if (paymentToken === FULL_DISCOUNT) {
        alert.show(t('success_payed', { ns: 'education' }), { type: 'success' });
        if (_.get(item, 'redirect_success') && item.redirect_success) {
          setModalSuccess(true);
          setTimeout(() => window.open(item.redirect_success, '_blank'), 5000);
        } else {
          history.push(`/account/educations/${_.get(item, 'url') || _.get(item, '_id')}`);
        }
        setPayLoading(false);
        return true;
      }
      history.push({
        pathname: '/account/checkout-education',
        state: {
          _id: _.get(model, '_id'),
          name: _.get(model, 'name'),
          promo: _.get(isPromo, 'promo', null),
          token: paymentToken,
          price: _.get(model, 'price_euro'),
        },
      });
    }
    return true;
  };

  const _payModules = async (mods, stripe) => {
    if (!_.get(me, '_id') || !me._id) {
      goAuth();
      return false;
    }
    if (!_.isEmpty(mods)) {
      const modules_id = mods.map((m) => m._id);
      setPayLoading(true);
      try {
        const response = await payProgress({
          variables: {
            stripe,
            mode: MODE_MODULES,
            model_id: _.get(item, '_id'),
            modules_id,
          },
        });
        const e = _.get(response, 'errors[0]', {});
        const paymentToken = _.get(response, 'data.payEducation', {});
        if (_.isEmpty(e) && paymentToken) {
          if (paymentToken && typeof window !== 'undefined') {
            if (stripe) {
              history.push({
                pathname: '/account/checkout-education',
                state: {
                  token: paymentToken,
                  modules: mods,
                },
              });
            } else {
              await paymentProcess({
                token: paymentToken,
                payStatus,
                refetchQueries: [
                  {
                    query: GQL_GET_ME,
                    fetchPolicy: 'network-only',
                  },
                ],
                onSuccess: () => {
                  successGo();
                },
                onFiled: () => {
                  alert.show(t('error_payment', { ns: 'education' }), { type: 'danger' });
                  setPayLoading(false);
                },
                onCancel: () => {
                  setPayLoading(false);
                },
              });
              return true;
            }
          }
        } else {
          alert.show(e.message, { type: 'danger' });
          setPayLoading(false);
        }
        return false;
      } catch (e) {
        alert.show(t('error_payment', { ns: 'education' }), { type: 'danger' });
        setPayLoading(false);
        // eslint-disable-next-line no-console
        console.log(e);
        return false;
      }
    }
    return true;
  };

  const selectVariant = async ({ model = {}, modules: mods = [] }) => {
    if (!_.get(me, '_id')) {
      goAuth();
      return false;
    }
    setVariant({ model, modules: mods });
    return true;
  };

  const closeWindow = () => {
    setModalSuccess(false);
    history.push(`/account/educations/${_.get(item, 'url') || _.get(item, '_id')}`);
  };
  // Render blocks
  const renderBlock = (pi, i = 0, ii = null) => (
    <BlockItem key={`p-${i + 1}-${ii + 1}`}>
      <CollapseNumber>
        {ii === null && (i + 1 < 10 ? `0${i + 1}` : i + 1)}
        {ii !== null && (ii + 1 < 10 ? `0${ii + 1}` : ii + 1)}
        {'. '}
      </CollapseNumber>
      <BlockAside>
        <Collapse onClick={() => collapseIt(`p-${i}-${ii}` === collapse ? null : `p-${i}-${ii}`)}>
          <CollapseName>{_.get(pi, 'name')}</CollapseName>
          <Plus isOpen={collapse === `p-${i}-${ii}` ? 1 : 0}>+</Plus>
        </Collapse>
        <CollapseText isOpen={collapse === `p-${i}-${ii}` ? 1 : 0}>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: _.get(pi, 'description') }} />
          {_.get(pi, 'price_rub') && (
            <ModulePrice onClick={scrollToPrice}>
              {t('can_bye_module', { ns: 'education' })}
              :
              {' '}
              {_.get(pi, 'price_rub')}
              {' '}
              {getCurrency(CURRENCY_RUB)}
            </ModulePrice>
          )}
        </CollapseText>
      </BlockAside>
    </BlockItem>
  );

  const renderProgram = () => {
    const hasModulesId = program.some((p) => p.modules_id && !!p.modules_id.length);

    if (_.isEmpty(modules) && !_.isEmpty(program) && !hasModulesId) {
      return (
        <BlockArea key="program">
          {program.map((p, i) => renderBlock(p, i))}
        </BlockArea>
      );
    }

    return (
      <BlockArea key="program">
        {!_.isEmpty(program) && hasModulesId
          ? program.map((p, i) => (
            <BlockSection key={`${_.get(p, 'name')}-${i + 1}`}>
              {_.get(p, 'name', '') && <BlockName>{_.get(p, 'name', '')}</BlockName>}
              {_.get(p, 'description', '') && (
              <BlockDescription
                dangerouslySetInnerHTML={{ __html: _.get(p, 'description', '') }}
              />
              )}
              {modules && modules
                .filter((m) => p.modules_id.includes(m._id))
                .map((pi, ii) => renderBlock(pi, i, ii))}
            </BlockSection>
          ))
          : modules && modules.map((pi, i) => renderBlock(pi, i))}
      </BlockArea>
    );
  };

  const renderLecturers = () => {
    if (_.isEmpty(lecturers)) {
      return '';
    }
    const sizes = {
      xl: 4000,
      lg: 1200,
      md: 1024,
      sm: 812,
    };

    const slidesCount = {
      xl: 1,
      lg: 1,
      md: 1,
      sm: 1,
    };
    return (
      <SlickSlider
        key="lecturers"
        sizes={sizes}
        slidesCount={slidesCount}
        items={lecturers.map((l) => (
          <SlideItem key={l._id}>
            <InfoLecturer>
              <NameLecturer to={`/@${_.get(l, 'username') || _.get(l, '_id')}`}>
                {l.name}
              </NameLecturer>
              <AboutLecturer dangerouslySetInnerHTML={{ __html: l.lecturer_info }} />
            </InfoLecturer>
            <ImageLecturer image={_.get(l, 'lecturer_image.key')} />
          </SlideItem>
        ))}
      />
    );
  };

  const renderTextBlock = (elements, key) => {
    if (_.isEmpty(elements)) {
      return '';
    }
    return (
      <Section key={key}>
        {elements.map((element, i) => (
          <ElementItem
            active={_.get(element, 'description', false) ? 1 : 0}
            // eslint-disable-next-line react/no-array-index-key
            key={`${_.get(element, 'name', '')}-${i}`}
          >
            <ElementNumber active={_.get(element, 'description', false) ? 1 : 0}>
              {i + 1}
            </ElementNumber>
            <ElementName active={_.get(element, 'description', false) ? 1 : 0}>
              {_.get(element, 'name')}
            </ElementName>
            {_.get(element, 'description') && (
              <ElementDescription
                dangerouslySetInnerHTML={{ __html: _.get(element, 'description') }}
              />
            )}
          </ElementItem>
        ))}
      </Section>
    );
  };

  const renderReviews = () => {
    const sizes = {
      xl: 4000,
      lg: 1200,
      md: 1024,
      sm: 600,
    };

    const slidesReviewsCount = {
      xl: 3,
      lg: 3,
      md: 2,
      sm: 1,
    };

    const components = [];
    if (!_.isEmpty(videoReviews)) {
      videoReviews.forEach((r) => components.push(
        <SlideVideoReview
          type="button"
          onClick={() => setVideo({
            cover: _.get(r, 'cover.key'),
            params: _.get(r, 'video', false),
          })}
          key={r._id}
        >
          <ImageVideoReview
            height={typeof window !== 'undefined' && window.innerWidth < 500 ? window.innerWidth - 82 : 350}
            image={_.get(r, 'cover.key')}
          >
            <PlayIcon />
          </ImageVideoReview>
          {_.get(r, 'owner.name') ? (
            <NameVideoLink to={`/@${_.get(r, 'owner.username') || _.get(r, 'owner._id')}`}>
              {_.get(r, 'owner.name')}
            </NameVideoLink>
          ) : (
            <NameVideo>{_.get(r, 'name')}</NameVideo>
          )}
        </SlideVideoReview>,
      ));
    }

    if (!_.isEmpty(reviews)) {
      reviews.forEach((r) => components.push(
        <SlideReview key={r._id}>
          <ImageReview image={_.get(r, 'owner.avatar.key')} />
          <InfoReview>
            <NameReview to={`/@${_.get(r, 'owner.username') || _.get(r, 'owner._id')}`}>
              {_.get(r, 'owner.name')}
            </NameReview>
            <Review dangerouslySetInnerHTML={{ __html: r.description }} />
          </InfoReview>
        </SlideReview>,
      ));
    }

    if (_.isEmpty(components)) {
      return '';
    }

    return (
      <SlickSlider
        key="slider"
        sizes={sizes}
        dots={isMobile}
        slidesCount={slidesReviewsCount}
        items={components}
      />
    );
  };

  const renderTariffs = () => {
    const isFree = (_.isEmpty(tariffs) && !_.get(item, 'purchased', false))
      || (!_.isEmpty(tariffs) && tariffs.length === 1 && tariffs.some((tf) => tf.price === 0));

    if (!_.get(item, 'can_view', false) && isFree) {
      return (
        <HiddenTariff
          id="tariffs"
          text={_.get(item, 'mainTariffs.0.close_text', '')}
          button={t('hidden_tariff', { ns: 'education' })}
        />
      );
    }

    if (_.get(item, 'closed', false) && !_.get(item, 'purchased', false)) {
      // If closed and not purchased, don't show anything
      return '';
    }

    if (isFree) {
      // If no tariffs, no modules and not purchased it's free
      return (
        <ButtonArea key="tariff" id="tariffs" ref={ref}>
          <Button disabled={payLoading} onClick={freeCourse}>
            {hasButton || t('go_my_education', { ns: 'education' })}
          </Button>
        </ButtonArea>
      );
    }

    if (_.get(item, 'purchased', false)) {
      // if purchased a return link to course in the cabinet
      return (
        <ButtonArea key="tariff" id="tariffs" ref={ref}>
          <ButtonLink
            to={isOpen
              ? `/account/educations/${_.get(item, 'url') || _.get(item, '_id')}`
              : '/account/educations'}
          >
            {t('go_my_education', { ns: 'education' })}
          </ButtonLink>
        </ButtonArea>
      );
    }
    // Else payments
    const hasPaymentModules = !_.isEmpty(modules) && modules.some((m) => !!m.price_rub && !!m.price_euro);

    return (
      <>
        {!_.get(item, 'can_view', false) && (
          <HiddenTariff
            text={_.get(item, 'mainTariffs.0.close_text', '')}
            button={t('hidden_tariff', { ns: 'education' })}
          />
        )}
        <Tariffs key="tariff" id="tariffs" ref={ref} count={tariffs.length + (hasPaymentModules ? 1 : 0)}>
          {hasPaymentModules && (
            <CourseModule
              selectVariant={selectVariant}
              count={tariffs.length + (hasPaymentModules ? 1 : 0)}
              hasTariff={!!tariffs.length}
              modules={modules}
              program={program}
              paid={_.get(item, 'paid_modules')}
              contact={context}
            />
          )}
          {tariffs.map((tariff) => (
            <Tariff
              key={tariff._id}
              me={me}
              modules={modules}
              program={program}
              selectVariant={selectVariant}
              count={tariffs.length + (hasPaymentModules ? 1 : 0)}
              promo={promo}
              newPrice={newPrice}
              newEuroPrice={newEuroPrice}
              isPromo={isPromo}
              model={tariff}
              loading={payLoading}
              paid={_.get(item, 'paid_modules')}
              contact={context}
            />
          ))}
        </Tariffs>
      </>
    );
  };

  const renderRegistrationForm = () => (!_.get(me, '_id')
    ? (<RegistrationBlock key="registration" t={t} text={_.get(item, 'registration', '')} />) : '');

  const renderComponents = {
    '{program}': renderProgram(),
    '{lecturers}': renderLecturers(),
    '{whatGive}': renderTextBlock(_.get(item, 'what_give', []), 'what_give'),
    '{whatLearn}': renderTextBlock(_.get(item, 'what_learn', []), 'what_learn'),
    '{whoSuit}': renderTextBlock(_.get(item, 'who_suit', []), 'who_suit'),
    '{reviews}': renderReviews(),
    '{tariffs}': renderTariffs(),
    '{registerForm}': renderRegistrationForm(),
    '{faq}': <FaqBlock faq={faq} />,
    '{sameCourses}': <RenderSameCourses key="courses" item={item} />,
    '{news}': <RenderNews key="news" item={item} />,
  };

  const components = renderStringToComponents(
    _.get(item, 'description'),
    renderComponents,
    DescriptionStyle,
  );

  const date = getTimeDateRange(_.get(item, 'started_at'), _.get(item, 'ended_at'));

  const image = _.get(item, 'cover.key') ? `/files/${_.get(item, 'cover.key')}` : '';

  const metaTags = _.get(item, 'meta')
    ? {
      title: _.get(item, 'meta.title', null),
      description: _.get(item, 'meta.description', null),
      published: _.get(item, 'meta.created_at', null),
      updated: _.get(item, 'meta.updated_at', null),
      image: image ? `${RU_DOMAIN}${image}` : null,
      path: `${RU_DOMAIN}/${EDUCATIONS_SECTION}/${
        _.get(item, 'url') || _.get(item, '_id')
      }`,
    }
    : null;

  return (
    <>
      <View className="frame-control" itemScope itemType="http://schema.org/Article">
        {_.get(item, 'updated_at') && <meta itemProp="dateModified" content={moment.unix(item.updated_at).format('Y-m-dTH:mm:s')} />}
        {_.get(item, 'created_at') && <meta itemProp="datePublished" content={moment.unix(item.created_at).format('Y-m-dTH:mm:s')} />}
        {metaTags && <MetaTags {...metaTags} />}
        {loading && (
          <div className="loader">
            <div className="bar" />
          </div>
        )}
        <Container>
          <BreadCrumbs to={`/${EDUCATIONS_SECTION}`}>
            {t('go_educations', { ns: 'education' })}
          </BreadCrumbs>
          <TopBlock>
            <div>
              {!_.isEmpty(_.get(item, 'tags', [])) && (
                <EducationTags>
                  {_.get(item, 'tags', []).map((tag) => (
                    <EducationTag to={`/educations?tags_id=${tag._id}`} key={_.get(tag, '_id')}>
                      {_.get(tag, 'name')}
                    </EducationTag>
                  ))}
                </EducationTags>
              )}
              <HeadLine>
                <H1 itemScope itemProp="headline">
                  {_.get(item, 'name', '')}
                </H1>
                {_.has(item, 'mainTariffs.0.name') && (
                  <TariffName color={_.get(item, 'mainTariffs.0.color', 'var(--art-rose)')}>
                    {_.get(item, 'mainTariffs.0.name')}
                  </TariffName>
                )}
              </HeadLine>
              <Anons dangerouslySetInnerHTML={{ __html: _.get(item, 'anons') }} />
              {!!lecturesNames.length && (
                <TopItem>
                  <TopLabel>
                    {lecturesNames.length > 1
                      ? t('course_lectors', { ns: 'education' })
                      : t('course_lector', { ns: 'education' })}
                    :
                  </TopLabel>
                  <TopName>{lecturesNames.map((lecture) => lecture)}</TopName>
                </TopItem>
              )}
              {!!_.get(item, 'lectures', []).length && _.get(item, 'lecture_count', false) && (
                <TopItem>
                  <TopLabel>
                    {t('lesson_lenght', { ns: 'education' })}
                    :
                  </TopLabel>
                  <TopName>
                    {_.get(item, 'lectures', []).length}
                    {' '}
                    {declinationName(_.get(item, 'lectures', []).length, [
                      t('lecture', { ns: 'education' }),
                      t('lectures_2', { ns: 'education' }),
                      t('lectures', { ns: 'education' }),
                    ])}
                  </TopName>
                </TopItem>
              )}
              {!!date && (
                <TopItem>
                  <TopLabel>
                    {t('start_date', { ns: 'education' })}
                  </TopLabel>
                  <TopName>{date}</TopName>
                </TopItem>
              )}
              <ButtonsTop>
                <ButtonsCatch mobile={isMobile ? 1 : 0} active={isInViewport ? 1 : 0}>
                  {_.get(item, 'purchased', false)
                  && _.get(item, 'can_view')
                  && !isInViewport && (
                  <ButtonLink
                    to={isOpen ? `/account/educations/${_.get(item, 'url') || _.get(item, '_id')}` : '/account/educations'}
                  >
                    {t('go_my_education', { ns: 'education' })}
                  </ButtonLink>
                  )}
                  {!_.get(item, 'closed', false)
                  && _.isEmpty(tariffs)
                  && _.get(item, 'can_view')
                  && !_.get(item, 'purchased', false) && !isInViewport && (
                    <Button type="button" disabled={payLoading} onClick={freeCourse}>
                      {hasButton || t('go_my_education', { ns: 'education' })}
                    </Button>
                  )}
                  {((!_.get(item, 'closed', false)
                  && !_.isEmpty(tariffs)
                  && !_.get(item, 'purchased', false)
                  && !isInViewport) || !_.get(item, 'can_view')) && (
                  <Button className="inside-btn" type="button" onClick={scrollToPrice}>
                    {hasButton || t('bye', { ns: 'education' })}
                  </Button>
                  )}
                  <BtnCircle type="button" onClick={context} active={isInViewport ? 1 : 0}>
                    <span className="inside-text">{t('have_questions', { ns: 'education' })}</span>
                    <span className="inside-icon">
                      <Q>?</Q>
                      <Icon
                        icon="message"
                        noHover
                        colorStroke="#ffffff"
                        colorFill="#ffffff"
                        width="22"
                        height="22"
                      />
                    </span>
                  </BtnCircle>
                </ButtonsCatch>
              </ButtonsTop>
            </div>
            <Cover image={image} />
          </TopBlock>
          {components.map((component) => component)}
        </Container>
      </View>
      {item && (<SuccessModal model={item} onHide={closeWindow} show={modalSuccess} t={t} />)}
      {video && (
        <VideoWrap>
          <CloseVideo type="button" onClick={() => setVideo(false)} />
          <ReactPlayer
            width="auto"
            height="100%"
            url={`/files/${_.get(video, 'params.key')}`}
            config={{
              file: {
                attributes: {
                  poster: `/files/${_.get(video, 'cover')}`,
                  playsInline: true,
                  autoPlay: true,
                  controls: true,
                  preload: 'none',
                  controlsList: 'nodownload',
                },
              },
            }}
          />
        </VideoWrap>
      )}
      {!_.isEmpty(variant) && (
        <VariantModal
          variant={variant}
          t={t}
          show={variant}
          onHide={() => setVariant(false)}
          bye={_bye}
          stripe={_stripePay}
          installment={_installment}
          byeModules={_payModules}
          loading={loading}
        />
      )}
    </>
  );
};

const HeadLine = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
`;

const TariffName = styled.div`
  position: relative;
  display: inline-flex;
  background-color: ${({ color }) => color};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  color: white;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  top: -5px;
`;

const BreadCrumbs = styled(Link)`
  color: var(--art-active);
  display: inline-flex;
  align-items: center;
  padding: 70px 0;
  position: relative;
  margin-left: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  text-decoration: none;
  &:after {
    content: "";
    display: block;
    width: 7px;
    height: 7px;
    position: absolute;
    left: -15px;
    border-left: 1px solid var(--art-active);
    border-bottom: 1px solid var(--art-active);
    transform: rotate(45deg);
    transition: left 150ms ease-in;
  }
  &:hover, &:focus {
    text-decoration: none;
    &:after {
      left: -20px;
      transition: left 150ms ease-in;
    }
  }
  @media screen and (max-width: 1024px) {
    padding: 45px 0;
  }
  @media screen and (max-width: 600px) {
    padding: 20px 0;
    font-size: 10px;
  }
`;

const View = styled.section`
  display: block;
  min-height: 50vh;
  padding-bottom: 80px;
  .slick-prev,
  .slick-next {
    border-radius: 50%;
    top: -64px;
  }
  .slick-prev {
    right: 71px;
  }
  .slick-dots {
    display: block !important;
    bottom: -50px !important;
    li {
      margin: 0 2px !important;
      button {
        &:before {
          width: 5px !important;
          height: 5px !important;
          background-color: #2931c3  !important;
        }
      }
    }
  }
  @media screen and (max-width: 812px) {
    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl {
      padding: 0 15px;
    }
  }
  @media screen and (max-width: 600px) {
    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl {
      padding: 0 18px;
    }
  }
`;

const TopBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.6fr;
  grid-gap: 60px;
  margin-bottom: 160px;
  @media screen and (max-width: 1100px) {
    margin-bottom: 100px;
    grid-gap: 40px;
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
  }
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    grid-gap: 0;
    margin-bottom: 0;
  }
`;

const LinkName = styled(Link)`
  color: var(--art-dark);
  &:hover,
  &:focus {
    color: var(--art-dark);
    text-decoration: none;
    border-bottom: 1px solid rgba(189, 189, 189, 1);
  }
`;

const Cover = styled.div`
  background-image: url('${({ image }) => image}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  border-radius: 30px;
  @media screen and (max-width: 768px) {
    height: 400px;
  }
  @media screen and (max-width: 600px) {
    border-radius: 20px;
    height: 260px;
  }
  @media screen and (max-width: 500px) {
    border-radius: 20px;
    height: 220px;
  }
  @media screen and (max-width: 440px) {
    border-radius: 20px;
    height: 136px;
  }
`;

const ButtonsTop = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-top: 23px;
  margin-bottom: 15px;
  @media screen and (max-width: 600px) {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const ButtonsCatch = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 600px) {
    display: grid;
    grid-template-columns: ${({ mobile, active }) => {
    if (mobile && !active) {
      return '5fr 1fr';
    }
    if (!mobile && !active) {
      return '5fr 1fr';
    }
    return '1fr';
  }};
    grid-column-gap: 20px;
    position: fixed;
    padding: 20px;
    left: 0;
    right: 0;
    width: 100%;
    bottom: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.35);
    box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(20px);
    button {
      margin-top: 0;
    }
    .inside-btn {
      padding: 12px 10px;
    }
  }
`;

const BtnCircle = styled.div`
  display: none;
  @media screen and (max-width: 600px) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .inside-text {
      display: ${({ active }) => (active ? 'block' : 'none')};
    }

    .inside-icon {
      width: 54px;
      height: 54px;
      min-width: 54px;
      min-height: 54px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      display: ${({ active }) => (!active ? 'flex' : 'none')};
      background-color: var(--art-active);
      position: relative;
    }  
    
    ${({ active }) => (active ? css`
      background-color: var(--art-active);
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 279px;
      padding: 15px 30px;
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      border-radius: 10px;
      width: 100%;
      &:hover,
      &:focus {
        color: white;
        text-decoration: none;
        background-color: var(--art-active-dark);
      }
    ` : '')};
`;

const Q = styled.div`
  right: 10px;
  top: 10px;
  position: absolute;
  color: var(--art-active);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 15px;
  width: 15px;
`;

const clickBtn = css`
  background-color: var(--art-active);
  color: white;
  min-width: 279px;
  padding: 15px 30px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  border-radius: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover,
  &:focus {
    color: white;
    text-decoration: none;
    background-color: var(--art-active-dark);
  }
  @media screen and (max-width: 768px) {
    min-width: auto;
  }
  @media screen and (max-width: 500px) and (orientation: portrait) {
    width: 100%;
  }
  @media screen and (max-width: 320px) {
    width: 100%;
  }
`;

const Button = styled.button`
  ${clickBtn};
`;

const ButtonLink = styled(Link)`
  ${clickBtn};
`;

const H1 = styled.h1`
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 20px;
  @media screen and (max-width: 1100px) {
    font-size: 34px;
  }
  @media screen and (max-width: 768px) {
    font-size: 28px;
  }
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
`;

const Anons = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 35px;
  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
  @media screen and (max-width: 600px) {
    font-size: 16px;
    margin-bottom: 25px;
  }
`;

const TopItem = styled.div`
  margin-bottom: 12px;
  @media screen and (max-width: 600px) {
    margin-bottom: 9px;
  }
`;

const TopLabel = styled.div`
  color: #9e9e9e;
  display: inline-block;
  font-feature-settings: 'liga' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-right: 10px;
  @media screen and (max-width: 600px) {
    font-size: 14px;
  }
`;

const TopName = styled.div`
  font-feature-settings: 'liga' off;
  display: inline-block;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  @media screen and (max-width: 600px) {
    font-size: 14px;
  }
`;

const Section = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  @media screen and (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ElementItem = styled.div`
  background-color: white;
  border-radius: 30px;
  padding: 30px;
  display: flex;
  flex-direction: ${({ active }) => (active ? 'column' : 'row')};
  @media screen and (max-width: 600px) {
    border-radius: 20px;
    padding: 18px;
  }
`;

const ElementNumber = styled.div`
  width: 27px;
  height: 27px;
  flex-shrink: 0;
  margin-right: ${({ active }) => (active ? 0 : 30)}px;
  background-color: var(--art-active);
  color: white;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ active }) => (active ? 15 : 0)}px;
  @media screen and (max-width: 600px) {
    width: 17px;
    height: 17px;
    font-size: 10px;
    margin-bottom: 10px;
  }
`;

const ElementName = styled.div`
  font-size: ${({ active }) => (active ? 20 : 24)}px;
  font-style: normal;
  font-weight: 700;
  line-height: 29px;
  margin-bottom: ${({ active }) => (active ? 15 : 0)}px;;
  @media screen and (max-width: 1070px) {
    font-size: 18px;
  }
  @media screen and (max-width: 991px) {
    font-size: 20px;
    line-height: 25px;
  }
  @media screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 10px;
  }
`;

const ElementDescription = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  @media screen and (max-width: 1070px) {
    font-size: 14px;
  }
  @media screen and (max-width: 991px) {
    font-size: 16px;
  }
  @media screen and (max-width: 600px) {
    font-size: 14px;
  }
`;

const SlideItem = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: white;
  border-radius: 30px;
  margin: 0 10px;
  @media screen and (max-width: 600px) {
    display: flex;
    border-radius: 20px;
    flex-direction: column-reverse;
  }
`;

const AboutLecturer = styled.div`
  display: block;
  p:last-child {
    margin-bottom: 0;
  }
`;

const NameLecturer = styled(Link)`
  font-weight: 700;
  font-size: 28px;
  line-height: 120%;
  margin-bottom: 10px;
  color: var(--art-dark);
  display: block;
  &:hover,
  &:focus {
    color: var(--art-dark);
    text-decoration: underline;
  }
  @media screen and (max-width: 812px) {
    font-size: 18px;
  }
  @media screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const ImageLecturer = styled.div`
  ${({ image }) => (image ? `background-image: url('/files/${image}')` : 'background: #333')};
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  min-height: 400px;
  border-radius: 30px;
  @media screen and (max-width: 840px) {
    background-position: center;
  }
  @media screen and (max-width: 600px) {
    height: 320px;
    border-radius: 20px;
    min-height: inherit;
  }
`;

const InfoLecturer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
  padding: 40px 50px;
  border-radius: 30px;
  @media screen and (max-width: 812px) {
    padding: 30px;
  }
  @media screen and (max-width: 600px) {
    padding: 18px;
    font-size: 14px;
    line-height: 140%;
    border-radius: 20px;
  }
`;

const BlockItem = styled.div`
  display: flex;
  border-bottom: 1px solid var(--art-main-gray);
  align-items: flex-start;
  gap: 30px;
  width: 100%;
  &:last-child {
    border-bottom: 0;
    button {
      margin-bottom: 20px;
    }
  }
  @media screen and (max-width: 600px) {
    gap: 0;
  }
`;

const BlockAside = styled.div`
  width: 100%;
`;

const BlockArea = styled.div`
  display: flex;
  padding: 30px 50px 20px 50px;
  flex-direction: column;
  align-items: flex-start;
  gap: 35px;
  border-radius: 30px;
  background: #fff;
  @media screen and (max-width: 600px) {
    gap: 25px;
    padding: 20px;
    border-radius: 20px;
  }
`;

const BlockSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  width: 100%;
`;

const BlockName = styled.div`
  font-weight: 700;
  font-size: 28px;
  line-height: 120%;
  margin-top: 50px;
  &:first-of-type {
    margin-top: 0;
  }
  @media screen and (max-width: 812px) {
    font-size: 24px;
  }
  @media screen and (max-width: 600px) {
    font-size: 18px;
  }
`;

const BlockDescription = styled.div`
  font-weight: 400;
  line-height: 140%;
  @media screen and (max-width: 812px) {
    font-size: 16px;
  }
  @media screen and (max-width: 600px) {
    font-size: 14px;
  }
`;

const Collapse = styled.button`
  padding: 0;
  display: flex;
  width: 100%;
  color: var(--art-dark);
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  text-align: left;
  @media screen and (max-width: 600px) {
    margin-bottom: 20px;
  }
`;

const CollapseNumber = styled.div`
  display: flex;
  font-size: 22px;
  line-height: 120%;
  color: var(--art-dark);
  font-weight: 400;
  align-items: center;
  @media screen and (max-width: 812px) {
    font-size: 18px;
  }
  @media screen and (max-width: 600px) {
    font-size: 16px;
    margin-right: 15px;
  }
`;

const CollapseName = styled.div`
  font-size: 20px;
  color: var(--art-dark);
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  padding: 0;
  @media screen and (max-width: 812px) {
    font-size: 18px;
  }
  @media screen and (max-width: 600px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
`;

const Plus = styled.div`
  font-size: 40px;
  color: var(--art-dark);
  line-height: 0;
  width: 24px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-weight: 300;
  transform: rotate(${({ isOpen }) => (isOpen ? 315 : 360)}deg);
  transition: transform 300ms ease;
  @media screen and (max-width: 600px) {
    font-size: 30px;
  }
`;

const CollapseText = styled.div`
  overflow: hidden;
  max-height: ${({ isOpen }) => (isOpen ? 10000 : 0)}px;
  transition: max-height 300ms ease;
  border-bottom: 1px solid rgba(5, 4, 54, 0.2);
  margin-bottom: ${({ isOpen }) => (isOpen ? 40 : 0)}px;
  &:last-of-type {
    border-bottom: 0;
  }
  @media screen and (max-width: 600px) {
    font-size: 14px;
    margin-left: -35px;
  }
`;

const ModulePrice = styled.button`
  color: var(--art-active);
  display: block;
  padding: 0;
  border: 0;
  background-color: transparent;
  font-weight: 700;
  line-height: 140%;
  font-size: 20px;
  @media screen and (max-width: 600px) {
    font-size: 16px;
  }
`;

const VideoWrap = styled.div`
  position: fixed;
  padding: 10%;
  width: 100%;
  height: 100%;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  background-color: rgba(5, 4, 54, 0.95);
  @media screen and (max-width: 640px) {
    video {
      width: 100% !important;
    }
  }
  @media screen and (max-width: 550px) {
    padding: 20% 10%;
  }
`;

const CloseVideo = styled.button`
  padding: 0 20px;
  line-height: 0;
  position: fixed;
  top: 25px;
  right: 45px;
  &:before,
  &:after {
    content: '';
    display: block;
    position: relative;
    width: 2px;
    height: 30px;
    background-color: white;
  }
  &:before {
    transform: rotate(45deg);
    top: 15px;
  }
  &:after {
    transform: rotate(-45deg);
    top: -15px;
  }
`;

const PlayIcon = styled.div`
  display: flex;
  z-index: 2;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #fff;
  width: 45px;
  height: 45px;
  right: 20px;
  top: 20px;
  position: absolute;
  &:before {
    content: '';
    position: relative;
    left: 7px;
    border: 9px solid transparent;
    border-left: 14px solid white;
  }
`;

const SlideVideoReview = styled.button`
  position: relative;
  text-align: left;
  display: block;
  background-color: white;
  border-radius: 30px;
  padding: 30px;
  width: 95%;
  max-height: 445px;
  text-overflow: ellipsis;
  @media screen and (max-width: 600px) {
    border-radius: 20px;
    padding: 20px;
    width: 100%;
  }
`;

const SlideReview = styled.div`
  display: flex;
  background-color: white;
  border-radius: 30px;
  padding: 30px;
  width: 95%;
  height: 445px;
  text-overflow: ellipsis;
  @media screen and (max-width: 600px) {
    width: 100%;
    flex-direction: column;
    border-radius: 20px;
  }
`;

const ImageVideoReview = styled.div`
  position: relative;
  z-index: 0;
  ${({ image }) => (image ? `background-image: url('/files/${image}')` : 'background: #333')};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: ${({ height }) => height}px;
  border-radius: 20px;
  overflow: hidden;
`;

const ImageReview = styled.div`
  ${({ image }) => (image ? `background-image: url('/files/${image}')` : 'background: #333')};
  background-size: cover;
  margin-right: 20px;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  min-width: 69px;
  min-height: 69px;
  width: 69px;
  height: 69px;
`;

const InfoReview = styled.div`
  display: block;
`;

const Review = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  height: 100%;
  max-height: 280px;
  overflow: visible scroll;
  @media screen and (max-width: 600px) {
    font-size: 14px;
  }
`;

const nameReview = css`
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  margin-top: 20px;
  display: inline-block;
  border-bottom: 1px solid transparent;
  color: var(--art-dark);
`;

const NameVideoLink = styled(Link)`
  ${nameReview};
  cursor: pointer;
  &:hover,
  &:focus {
    color: var(--art-dark);
    text-decoration: none;
    border-bottom: 1px solid rgba(189, 189, 189, 1);
  }
`;

const NameVideo = styled.div`
  ${nameReview};
`;

const NameReview = styled(Link)`
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
  margin-bottom: 15px;
  border-bottom: 1px solid transparent;
  color: var(--art-dark);
  cursor: pointer;
  display: inline-block;
  &:hover,
  &:focus {
    color: var(--art-dark);
    text-decoration: none;
    border-bottom: 1px solid rgba(189, 189, 189, 1);
  }
`;

const ButtonArea = styled.div`
  margin-top: 60px;
  text-align: center;
`;

const Tariffs = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${({ count }) => {
    if (count === 3) {
      return 3;
    }
    if (count === 1) {
      return 1;
    }
    return 2;
  }},
    1fr
  );
  grid-gap: 20px;
  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 750px) {
    grid-gap: 0;
    display: flex;
    flex-direction: column;
    > div {
      margin-bottom: 20px;
    }
  }
`;

const EducationTags = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 30px;
  @media screen and (max-width: 600px) {
    margin-bottom: 25px;
  }
`;

const EducationTag = styled(Link)`
  color: var(--art-dark);
  display: flex;
  padding: 5px 10px;
  align-items: center;
  gap: 4px;
  border-radius: 5px;
  border: 1px solid var(--art-dark);
  margin-right: 10px;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  &:hover,
  &:focus {
    text-decoration: none;
    background-color: var(--art-dark);
    color: white;
  }
  @media screen and (max-width: 600px) {
    font-size: 10px;
  }
`;

EducationView.defaultProps = {
  me: {},
};

EducationView.propTypes = {
  me: PropTypes.object,
  match: PropTypes.object.isRequired,
  ChatContext: PropTypes.object.isRequired,
};

export default EducationView;
